// extracted by mini-css-extract-plugin
export default {"scene":"HorizonScene_scene__-RIh4","earth":"HorizonScene_earth__3c6YD"};